<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="tnis">I can now sing “I am what I am” with true conviction because I allow only the one who made me to define “What I Am.”</p>
<p class="tni">I can now sing “I Will Survive” with true conviction because my strength to live and assurance that I will comes from submission to the only one who can create life … <span class="epub-i">Jesus Christ.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?6edc4c98